<template>
  <div class="w-full h-full product-packages-wrapper">
    <ProductPackages />
  </div>
</template>

<script>
import ProductPackages from '@/modules/productPackages/index.vue'
export default {
  components: {
    ProductPackages,
  },
}
</script>

<style scoped>
.product-packages-wrapper {
  background-color: white;
}
</style>
